<template>
  <div class="wrapper">
    <!-- data Table -->
    <div>
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="
                d-flex
                justify-content-between
                align-items-center
                bg-secondary
              "
            >
              <h5 class="text-light m-0 p-0">تنظیمات‌</h5>
            </CCardHeader>
            <CCardBody>
              <!-- <div class="col-sm-12 col-md-6 col-lg-4">
                <label class="typo__label">زبان</label>
                <multiselect
                  class="needs-validation"
                  v-model="selectedLanguage"
                  :options="languageList"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب زبان..."
                  label="label"
                  track-by="value"
                  @onChange="$i18n.locale = this.selectedLanguage.value;"
                ></multiselect>
              </div> -->

              <div class="">
                <h6>زبان</h6>
                <select
                  v-model="$i18n.locale"
                  class="col-sm-12 col-md-6 col-lg-4 text-secondary"
                >
                  <option
                    v-for="(lang, i) in langs"
                    :key="`lang-${i}`"
                    :value="lang.value"
                  >
                    {{ lang.label }}
                  </option>
                </select>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "SwitchLocale",
  components: {
    Multiselect,
  },
  data() {
    return {
      langs: [
        { label: "فارسی", value: "fa" },
        { label: "English", value: "en" },
      ],
      languageList: [
        { label: "English", value: "en" },
        { label: "فارسی", value: "fa" },
      ],
      selectedLanguage: {},
    };
  },
  methods: {
    setLanguage() {
      $i18n.locale = this.selectedLanguage.value;
      console.log($i18n.locale);
    },
  },
};
</script>

<style>
select {
  width: 150px;
  line-height: 49px;
  height: 38px;
  font-size: 22px;
  outline: 0;
  margin-bottom: 15px;
}
</style>
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>